import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Toast, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
	IoIosClose,
	IoMdDownload,
	IoMdDoneAll,
	IoMdCreate,
	IoMdCalendar,
	IoMdTrash,
} from "react-icons/io";
import ReactTable from "../../../../components/FilterTable";
import { _HttpServices } from "../../../../_services/_HttpServices";
import Loader from "../../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import moment from "moment";
import { useHistory } from "react-router";
import getExcel from "../../../../_services/ExcelUtility";
import { Footer } from "../../../../components/Footer";
import { number, string } from "prop-types";

const GenentechInventoryEdit = (props) => {
	let fileName = "Inventory Source Data";
	const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));

	const Genentechinventory = JSON.parse(localStorage.getItem("inventory"));
	const userData = localStorage.getItem("userData");
	const history = useHistory();
	// const [sales, setSales] = useState([]);
	// const [gridSales, setGridSales] = useState([]);
	const [gridData, setGridData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const [showCOnfirm, setShowConfirm] = useState(false);
	const [addshowConfirm, setaddShowConfirm] = useState(false);
	// const [gridShow, setGridShow] = useState(false);
	// const [cont, setCont] = useState({});
	const [chargeback, setChargeBack] = useState({});
	const [inventory, setInventory] = useState({});
	const [indicator, setIndicator] = useState(false);
	const [editOrSaveInd, setEditOrSaveInd] = useState(false);
	const [disableSubmit, setSubmitDisable] = useState(false);
	const [addDisableSubmit, setAddSubmitDisable] = useState(false);
	const [showToaster, setShowToaster] = useState(false);
	const initialvalues = {
		AvailableQuantity: "",
		DistributorAccount: "",
		DistributorName: "",
		EndofMonthInventory: "",
		ExpirationDate: "",
		FileProcessID: "",
		LotNumber: "",
		NDC: "",
		ProductName: "",
		QP: "",
		QR: "",
		QS: "",
		Total: "",
		TotalUnit: "",
		UnitsOrVial: "",
	};
	// const [newChargeBack, setNewChargeBack] = useState(initialvalues);
	const [newInventory, setNewInventory] = useState(initialvalues);
	const [editIndex, setEditIndex] = useState();

	//
	const Gridcolumns = [
		{
			Header: "Actions",
			accessor: "accessor",
			disableFilters: true,
			disableSortBy: true,
			width: 130,
			accessor: "accessor",

			Cell: (row) => (
				<Fragment>
					<Button
						variant="link"
						onClick={() => editReport(row)}
						className="grid-action-btn ml-2"
						title="Edit Row"
					>
						<IoMdCreate className="icon" />
					</Button>
					<Button
						variant="link"
						onClick={() => deleteRecord(row)}
						className="grid-action-btn ml-2"
						title="Delete Row"
					>
						<IoMdTrash className="icon fa-icon" />
					</Button>
					{/* <Button variant="link" onClick={() => copyReport(row.row.original)} className="grid-action-btn ml-2" title="Disable Task">
                        <IoMdCreate className="icon" />
                    </Button> */}
				</Fragment>
			),
		},
		{
			Header: "Assigned_Customer_Key",
			accessor: "Assigned_Customer_Key",
			filter: "Assigned_Customer_Key",
			sortType: "basic",
			width: 200,
			key: true,
		},
		{
			Header: "Dc_ID_Key",
			accessor: "Dc_ID_Key",
			filter: "Dc_ID_Key",
			sortType: "basic",
			width: 120,
			key: true,
		},
		{
			Header: "Dc_ID_Qual",
			accessor: "Dc_ID_Qual",
			filter: "Dc_ID_Qual",
			sortType: "basic",
			width: 115,
			key: true,
		},
		{
			Header: "NdcUpc",
			accessor: "NDC",
			filter: "NDC",
			sortType: "basic",
			width: 120,
			key: true,
		},
		{
			Header: "NdcUpc_Qual",
			accessor: "NdcUpc_Qual",
			filter: "NdcUpc_Qual",
			sortType: "basic",
			width: 120,
			key: true,
		},
		{
			Header: "Reporting Date",
			accessor: "ReportingDate",
			filter: "ReportingDate",
			sortType: "basic",
			width: 120,
			field: true,
			key: true,
			filterMethod: (filter, row) => {
				const rowValue = row.original;
				return rowValue.datefiled.includes(filter.value);
			},
		},
		{
			Header: "UOM",
			accessor: "UOM",
			filter: "UOM",
			sortType: "basic",
			width: 100,
			key: true,
		},
		// ==================
		{
			Header: "AM",
			accessor: "AM",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "BS",
			accessor: "BS",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "BT",
			accessor: "BT",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "DD",
			accessor: "DD",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "DS",
			accessor: "DS",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "HL",
			accessor: "HL",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "IT",
			accessor: "IT",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "LF",
			accessor: "LF",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "LO",
			accessor: "LO",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "LS",
			accessor: "LS",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "MS",
			accessor: "MS",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "OF",
			accessor: "OF",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "OP",
			accessor: "OP",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "OQ",
			accessor: "OQ",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "PA",
			accessor: "PA",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "PO",
			accessor: "PO",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "Q1",
			accessor: "Q1",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "Q2",
			accessor: "Q2",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "Q3",
			accessor: "Q3",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "Q4",
			accessor: "Q4",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		// ==============
		{
			Header: "QA",
			accessor: "AvailableQuantity",
			filter: "AvailableQuantity",
			sortType: "basic",
			width: 80,
			// key: true
		},
		// ==================
		{
			Header: "QB",
			accessor: "QB",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "QC",
			accessor: "QC",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "QD",
			accessor: "QD",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "QE",
			accessor: "QE",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "QF",
			accessor: "QF",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "QH",
			accessor: "QH",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "QI",
			accessor: "QI",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "QK",
			accessor: "QK",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "QL",
			accessor: "QL",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "QM",
			accessor: "QM",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "QN",
			accessor: "QN",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "QO",
			accessor: "QO",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},

		// ==================
		{
			Header: "QP",
			accessor: "QP",
			filter: "QP",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "QR",
			accessor: "QR",
			filter: "QR",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "QS",
			accessor: "QS",
			filter: "QS",
			sortType: "basic",
			width: 80,
		},
		// ==================
		{
			Header: "QT",
			accessor: "QT",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "QU",
			accessor: "QU",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "QW",
			accessor: "QW",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "QX",
			accessor: "QX",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "QZ",
			accessor: "QZ",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "RE",
			accessor: "RE",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "TC",
			accessor: "TC",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "TM",
			accessor: "TM",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "TS",
			accessor: "TS",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "WQ",
			accessor: "WQ",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "WS",
			accessor: "WS",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
		{
			Header: "ZZ",
			accessor: "ZZ",
			// disableFilters: true,
			// disableSortBy: true,
			require: true,
		},
	];

	//

	//
	useEffect(() => {
		// getAdvanceShipNotice();
		setGridData(Genentechinventory);
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;
		console.log(e);
		if (
			name === "NDC" ||
			name === "AvailableQuantity" ||
			name === "TotalUnit" ||
			name === "UnitsOrVial"
		) {
			const re = /^[($)\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setInventory((values) => ({
					...values,
					[name]: value,
				}));
			}
		} else {
			setInventory((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};
	const newhandleChange = (e) => {
		const { name, value } = e.target;
		console.log(e);
		if (
			name === "NDC" ||
			name === "AvailableQuantity" ||
			name === "TotalUnit" ||
			name === "UnitsOrVial"
		) {
			const re = /^[($)\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setNewInventory((values) => ({
					...values,
					[name]: value,
				}));
			}
		} else {
			setNewInventory((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};
	function copyReport(row) {
		// delete gridSales[row.row.index];
		let obj = Object.assign({}, row);
		obj.ind = gridData.length + 1;
		const row1 = Object.assign({}, obj);
		gridData.push(row1);
		const deletedData = Object.assign([], gridData);
		setGridData(deletedData);
	}
	function deleteRecord(row) {
		console.log(row.row.original);

		// delete gridData[row.row.index];
		let data = gridData.filter((element, index) => {
			return index !== row.row.index;
		});
		const deletedData = Object.assign([], data);
		setGridData(deletedData);
	}
	const handleChangeDate = (date, i) => {
		const re = i;
		setInventory((values) => ({
			...values,
			ReportingDate: date,
		}));
	};

	useEffect(() => {
		setSubmitDisable(validateForm());
	}, [newInventory]);
	useEffect(() => {
		setAddSubmitDisable(validateEditForm());
	}, [inventory]);

	const validateEditForm = () => {
		if (
			inventory.Assigned_Customer_Key &&
			inventory.Assigned_Customer_Key.toString().trim() !== "" &&
			inventory.Dc_ID_Key &&
			inventory.Dc_ID_Key.toString().trim() !== "" &&
			inventory.Dc_ID_Qual &&
			inventory.Dc_ID_Qual.toString().trim() !== "" &&
			inventory.NDC &&
			inventory.NDC.toString().trim() !== "" &&
			inventory.NdcUpc_Qual &&
			inventory.NdcUpc_Qual.toString().trim() !== "" &&
			inventory.UOM &&
			inventory.UOM.toString().trim() !== ""
		) {
			return false;
		} else {
			return true;
		}
	};
	const validateForm = () => {
		if (
			newInventory.Assigned_Customer_Key &&
			newInventory.Assigned_Customer_Key.toString().trim() !== "" &&
			newInventory.Dc_ID_Key &&
			newInventory.Dc_ID_Key.toString().trim() !== "" &&
			newInventory.Dc_ID_Qual &&
			newInventory.Dc_ID_Qual.toString().trim() !== "" &&
			newInventory.NDC &&
			newInventory.NDC.toString().trim() !== "" &&
			newInventory.NdcUpc_Qual &&
			newInventory.NdcUpc_Qual.toString().trim() !== "" &&
			newInventory.UOM &&
			newInventory.UOM.toString().trim() !== ""
		) {
			return false;
		} else {
			return true;
		}
	};
	function saveRowHandler() {
		// res.ReportingDate = moment(res.ReportingDate).format('YYYYMMDD')

		newInventory.AM = 0;
		newInventory.BS = 0;
		newInventory.BT = 0;
		newInventory.DD = 0;
		newInventory.DS = 0;
		newInventory.HL = 0;
		newInventory.IT = 0;
		newInventory.LF = 0;
		newInventory.LO = 0;
		newInventory.LS = 0;
		newInventory.MS = 0;
		newInventory.OF = 0;
		newInventory.OP = 0;
		newInventory.OQ = 0;
		newInventory.PA = 0;
		newInventory.PO = 0;
		newInventory.Q1 = 0;
		newInventory.Q2 = 0;
		newInventory.Q3 = 0;
		newInventory.Q4 = 0;
		newInventory.QB = 0;
		newInventory.QC = 0;
		newInventory.QD = 0;
		newInventory.QE = 0;
		newInventory.QF = 0;
		newInventory.QH = 0;
		newInventory.QI = 0;
		newInventory.QK = 0;
		newInventory.QL = 0;
		newInventory.QM = 0;
		newInventory.QN = 0;
		newInventory.QO = 0;
		newInventory.QT = 0;
		newInventory.QU = 0;
		newInventory.QW = 0;
		newInventory.QX = 0;
		newInventory.QZ = 0;
		newInventory.RE = 0;
		newInventory.TC = 0;
		newInventory.TM = 0;
		newInventory.TS = 0;
		newInventory.WQ = 0;
		newInventory.WS = 0;
		newInventory.ZZ = 0;

		newInventory.ReportingDate = moment(
			newInventory.ReportingDate ? newInventory.ReportingDate : new Date()
		).format("YYYY/MM/DD");
		const ns = Object.assign({}, newInventory);
		gridData.unshift(ns);
		setaddShowConfirm(false);
		setNewInventory(initialvalues);
	}
	function editRowHandler() {
		let indicator = 0;
		inventory.ReportingDate = moment(
			inventory.ReportingDate ? inventory.ReportingDate : new Date()
		).format("YYYY/MM/DD");
		if (editOrSaveInd) {
			gridData.filter((element, index) => {
				if (editIndex === index) {
					const cbk = Object.assign({}, inventory);
					gridData[index] = cbk;
				}
			});
		}

		indicator = 1;
		// }

		if (indicator != 0) {
			console.log(inventory);
			setShowConfirm(false);
			setIndicator(false);
		} else {
			setIndicator(true);
		}
	}
	const editReport = (inventory) => {
		// setDeleteTask(task)
		setEditIndex(inventory.row.index);
		setInventory(inventory.row.original);
		setShowConfirm(true);
		setEditOrSaveInd(true);
	};

	const EditRecords = () => {
		// setShowConfirm(true);
		// setGridShow(true);
	};
	const saveRecords = () => {
		//    setCont({})
		// setShowConfirm(true);
		setaddShowConfirm(true);
		setEditOrSaveInd(false);
	};

	const saveallRecords = () => {
		let dataList = [];
		gridData.map((element) => {
			let dataobj = {};
			dataobj.NDC = element.NDC;

			dataobj.AvailableQuantity = element.AvailableQuantity;
			dataobj.ExpirationDate = new Date();
			dataobj.ReportingDate = element.ReportingDate;
			dataobj.QR = element.QR;
			dataobj.QS = element.QS;
			dataobj.Assigned_Customer_Key = element.Assigned_Customer_Key;
			dataobj.Dc_ID_Key = element.Dc_ID_Key;
			dataobj.Dc_ID_Qual = element.Dc_ID_Qual;
			dataobj.NdcUpc_Qual = element.NdcUpc_Qual;
			dataobj.UOM = element.UOM;
			dataobj.QP = element.QP;
			// =======================
			dataobj.FileProcessID = Genentechinventory[0].FileProcessID;
			dataobj.ModifiedOn = new Date();
			dataobj.LastModifiedBy = JSON.parse(userData).UserName;
			dataobj.IsResendRequired =
				outbounddata.FileSentStatus == "Sent" ? true : false;
			dataobj.IsReadyforReversal = true;
			dataobj.IsEdited = true;
			dataobj.Version = 1;
			dataobj.Service_Task_Id = outbounddata.ServiceTaskID;
			dataList.push(dataobj);
		});

		setLoading(true);
		_HttpServices
			.postData("Api/Edi844/Reversal852ExcelOutbound", dataList)
			.then((data) => {
				if (data.data === "") {
					setLoading(false);
					setShowToaster(true);
					setTimeout(() => history.push("/outbound-reports"), 1000);
				}
			})
			.catch((e) => {
				setLoading(false);
			});
	};
	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">{fileName}</h2>
				{loading ? <Loader /> : null}
				<Toast
					onClose={() => setShowToaster(false)}
					show={showToaster}
					delay={1500}
					autohide
					className="custom-toaster"
				>
					<Toast.Body>Details updated successfully</Toast.Body>
				</Toast>
				<div>
					<Button variant="primary" type="button" onClick={() => saveRecords()}>
						Add Record
					</Button>
					{/* <Button type="submit" onClick={() =>EditRecords()}>EditRecords</Button> */}

					<Button
						className="ml-2"
						type="submit"
						onClick={() => getExcel(Gridcolumns, gridData, fileName)}
					>
						<IoMdDownload className="icon btn-icon" />
						Download Excel{" "}
					</Button>
				</div>
				{/* insert */}

				<Modal
					show={addshowConfirm}
					onHide={() => setaddShowConfirm(false)}
					backdrop="static"
					keyboard={false}
					size="lg"
				>
					<Modal.Header closeButton>
						<Modal.Title>
							{/* <span className="err-msg">{indicator && "please fill the fields"}</span> */}
							Add Record
						</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<Row>
							<Col md={12}>
								<div className="card pt-2 mb-4">
									<div className="card-body">
										<Form>
											{/*dyn  */}
											<Row>
												{Gridcolumns.map(function (i) {
													return (
														i.accessor != "accessor" && (
															<Col md={3}>
																<Form.Group>
																	<div className="date-picker ungroup-date-picker pos-rl">
																		<Form.Label
																			htmlFor="StartDate"
																			title={i.Header}
																		>
																			{/* Since */}
																			{i.accessor != "accessor" ? i.Header : ""}
																			{i.key && (
																				<span className="err-msg">*</span>
																			)}
																		</Form.Label>
																		{i.field && (
																			<IoMdCalendar className="icon date-icon" />
																		)}
																		{i.field && (
																			<DatePicker
																				key={newInventory[i.accessor]}
																				selected={
																					newInventory[i.accessor]
																						? new Date(
																								moment(
																									newInventory[i.accessor]
																								).format("YYYY/MM/DD")
																						  )
																						: new Date()
																				}
																				onChange={(e) =>
																					setNewInventory((values) => ({
																						...values,
																						[i.accessor]: e,
																					}))
																				}
																				maxDate={new Date()}
																			/>
																		)}
																		{!i.field && (
																			<Form.Control
																				required
																				type="text"
																				name={i.accessor}
																				value={newInventory[i.accessor]}
																				key={inventory[i.accessor]}
																				onChange={(e) => newhandleChange(e)}
																				disabled={i.require}
																			/>
																		)}
																	</div>
																</Form.Group>
															</Col>
														)
													);
												})}
											</Row>
											{/*  dyn*/}
										</Form>
									</div>
								</div>
							</Col>
						</Row>

						{/*  */}
					</Modal.Body>
					<Modal.Footer>
						<div className="text-right mt-2">
							<Button
								type="submit"
								disabled={disableSubmit}
								onClick={() => saveRowHandler()}
							>
								<IoMdDoneAll className="icon btn-icon" />
								Save
							</Button>
							<Button
								variant="danger"
								className="ml-3 btn-sm"
								onClick={() => setaddShowConfirm(false)}
							>
								<IoIosClose className="icon btn-icon" />
								Cancel
							</Button>
						</div>
					</Modal.Footer>
				</Modal>
				{/* insert end */}
				{/* Modal */}
				<Modal
					show={showCOnfirm}
					onHide={() => setShowConfirm(false)}
					backdrop="static"
					keyboard={false}
					size="lg"
				>
					<Modal.Header closeButton>
						<Modal.Title>
							{/* <span className="err-msg">{indicator && "please fill the fields"}</span> */}
							Edit Record
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Row>
							<Col md={12}>
								<div className="card pt-2 mb-4">
									<div className="card-body">
										<Form>
											{/*dyn  */}
											<Row>
												{Gridcolumns.map(function (i) {
													return (
														i.accessor != "accessor" && (
															<Col md={3}>
																<Form.Group>
																	<div className="date-picker ungroup-date-picker pos-rl">
																		<Form.Label htmlFor="StartDate">
																			{/* Since */}
																			{i.accessor != "accessor" ? i.Header : ""}
																			{i.key && (
																				<span className="err-msg">*</span>
																			)}
																		</Form.Label>
																		{i.field && (
																			<IoMdCalendar className="icon date-icon" />
																		)}
																		{i.field && (
																			<DatePicker
																				key={inventory[i.accessor]}
																				// selected = {i.field)}
																				selected={
																					i.field
																						? new Date(
																								moment(
																									inventory[i.accessor]
																								).format("YYYY/MM/DD")
																						  )
																						: new Date()
																				}
																				onChange={(e) =>
																					setInventory((values) => ({
																						...values,
																						[i.accessor]: e,
																					}))
																				}
																				maxDate={new Date()}
																			/>
																		)}
																		{/* {i.Header.indexOf('Date') == -1  && <Form.Control */}
																		{!i.field && (
																			<Form.Control
																				required
																				type="text"
																				name={i.accessor}
																				value={inventory[i.accessor]}
																				// key={cont[i.accessor]}
																				onChange={(e) => handleChange(e)}
																				disabled={i.require}
																			/>
																		)}
																	</div>
																</Form.Group>
															</Col>
														)
													);
												})}
											</Row>
											{/*  dyn*/}
										</Form>
									</div>
								</div>
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						<div className="text-right mt-2">
							<Button
								disabled={addDisableSubmit}
								onClick={() => editRowHandler()}
							>
								<IoMdDoneAll className="icon btn-icon" />
								Edit Row
							</Button>
							<Button
								variant="danger"
								className="ml-3 btn-sm"
								onClick={() => setShowConfirm(false)}
							>
								<IoIosClose className="icon btn-icon" />
								Cancel
							</Button>
						</div>
					</Modal.Footer>
				</Modal>
			</div>

			<Row>
				<Col md={12}>
					{/* <Row> */}
					<span className="mb-4 h6">
						File Name: {outbounddata.File_Process_Name}
					</span>{" "}
					<span className="ml-4 h6">Version: {outbounddata.Fileversion}</span>
					{/* </Row> */}
					<div className="card pt-2">
						<div className="card-body">
							<div className="inventory-grid">
								{hasError ? (
									<p>Error occurred. Unable to load {fileName}</p>
								) : (
									<Fragment>
										{gridData.length > 0 ? (
											<ReactTable
												columns={Gridcolumns}
												data={gridData}
												defaultPageSize={10}
											/>
										) : (
											<div className="no-data">No data found.</div>
										)}
									</Fragment>
								)}
							</div>
						</div>
					</div>
				</Col>
			</Row>
			{/*end  */}
			<Row>
				<Col md={12} className="text-right mt-2">
					{gridData.length > 0 && (
						<Button
							variant="primary"
							type="button"
							onClick={() => saveallRecords()}
						>
							Save Records
						</Button>
					)}
					<Button
						variant="danger"
						type="button"
						className="ml-3"
						onClick={() => history.goBack()}
					>
						<IoIosClose className="icon btn-icon" />
						Cancel
					</Button>
				</Col>
			</Row>
			<Footer />
		</section>
	);
};
export default GenentechInventoryEdit;
